import Phaser from 'phaser';
import { VIEWPORT_W } from '../../constants';
import { onGame, offGame, GameEvents } from '../../events';
import { playerState } from '../../player-state';
import type { WeaponModel } from '../types';
import { createWeaponHitView } from './weapon-hit-view';

function isWoodClubEquipped() {
  const weapon = playerState.equipped.weapon;
  return weapon === 'WoodClub' || weapon === 'Wood Club';
}

export function createWeaponComponent(scene: Phaser.Scene, model: WeaponModel) {
  let currentModel = model;
  const getModel = () => currentModel;
  const view = createWeaponHitView(scene, getModel);

  const onGeodeHit = (payload: unknown) => {
    const { x = 0, y = 0 } = (payload ?? {}) as { x?: number; y?: number };
    view.playHit(playerState.equipped.weapon, x, y);
  };

  const syncIdle = (scrollX: number) => {
    const onSmashPanel = scrollX > VIEWPORT_W * 0.5;
    if (onSmashPanel && isWoodClubEquipped()) {
      view.showIdle();
    } else {
      view.hide();
    }
  };

  const onHudRefresh = () => {
    syncIdle(scene.cameras.main.scrollX);
  };

  const onViewportResize = () => {
    view.refreshIdle();
  };

  onGame(GameEvents.GEODE_HIT, onGeodeHit);
  onGame(GameEvents.HUD_REFRESH, onHudRefresh);
  scene.game.scale.on('resize', onViewportResize);

  function setModel(next: WeaponModel) {
    currentModel = next;
    view.refreshIdle();
  }

  function syncFromScroll(scrollX: number) {
    syncIdle(scrollX);
  }

  return {
    playHit: view.playHit,
    setModel,
    syncFromScroll,
    destroy() {
      offGame(GameEvents.GEODE_HIT, onGeodeHit);
      offGame(GameEvents.HUD_REFRESH, onHudRefresh);
      scene.game.scale.off('resize', onViewportResize);
      view.destroy();
    },
  };
}

export { queueWeaponLoad, prepareWeapon } from './weapon-load';
